import Image from 'next/image'
import {Dispatch, SetStateAction, useState, useEffect} from 'react'
import LogoImage from '../../public/images/logo.svg'
import MobileMenuItem from './MobileMenuItem'
import LoggedInUserMobile from './LoggedInUserMobile'
import MobileContactHeader from './MobileContactHeader'
import {AnimatePresence, motion} from 'framer-motion'
import Link from 'next/link'
import {useCartState} from '@/contexts/CartContext'
import useAuth from '@/hooks/useAuth'
import {useRouter} from 'next/router'
import CartIcon from './Cart/CartIcon'
import Button from './Button'
import * as fbq from '@/services/fbpixel'
import {event} from 'nextjs-google-analytics'

type Props = {
  setIsLoginOpen: (arg0: boolean) => void
  setIsRegisterOpen: (arg0: boolean) => void
  setIsForgotOpen: (arg0: boolean) => void
  setLastOpened: Dispatch<SetStateAction<'login' | 'register'>>
  lastOpened: 'login' | 'register'
  headerCategories: any
}
export default function MobileHeader({
  setIsLoginOpen,
  setIsForgotOpen,
  setIsRegisterOpen,
  setLastOpened,
  lastOpened,
  headerCategories,
}: Props) {
  const [navbar, setNavbar] = useState(false)
  const [isNavOpen, setIsNavOpen] = useState(false)
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [search, setSearch] = useState('');

  useEffect(() => {
  }, [isSearchOpen])
  function toggleClick() {
    setNavbar(!navbar)
    setIsNavOpen(!isNavOpen)
  }
  const {user} = useAuth('none')
  const router = useRouter()
  const cart = useCartState()

  const SubmitSearch = ({queryFromButton}: {queryFromButton: string}) => {
  const params = new URLSearchParams({
    query: queryFromButton ? queryFromButton : search,
  })
    event('search', {
      search_term: search,
    })
    fbq.event('Search', {
      search_string: search,
    })
    setIsSearchOpen(false);
    router.push('/products?' + params.toString(), undefined, {scroll: false})
    return
  }

  const suggestedSearches = [
    {
      id: 1,
      text: "تتعلم الابجدية",
    },
    {
      id: 2,
      text: "في الصف الأول",
    },
    {
      id: 3,
      text: "عيد ميلاد",
    },
    {
      id: 4,
      text: "أسنان ليان",
    }
  ];
  const bestSelling = [
    {
      id: 1,
      text: 'عيد ميلاد جنة',
    },
    {
      id: 2,
      text: 'فرح تحب أختها',
    },
    {
      id: 3,
      text: 'أسنان ليان',
    },
    {
      id: 4,
      text: 'كرم فنان بالالوان',
    }
  ];
  return (
    <>
      <div className="header-inner relative lg:hidden flex items-center justify-between">

        {/* search div (modal) */}

        <AnimatePresence>
          {isSearchOpen && (
          <motion.div
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'tween', duration: 0.4 }} 
            className='absolute bg-white w-[70vw] mr-0 top-[3.54rem] -right-[1.45rem] h-[100vh] p-8 flex flex-col items-center justify-start gap-6'>
              
              <button className='w-full flex items-center justify-end' onClick={() => setIsSearchOpen(false)}>
                <span className='w-8 h-8 bg-[#93A3B03D] rounded-md'>
                  <svg viewBox="0 -0.5 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier"></g><g id="SVGRepo_tracerCarrier"></g><g id="SVGRepo_iconCarrier"> <path d="M6.96967 16.4697C6.67678 16.7626 6.67678 17.2374 6.96967 17.5303C7.26256 17.8232 7.73744 17.8232 8.03033 17.5303L6.96967 16.4697ZM13.0303 12.5303C13.3232 12.2374 13.3232 11.7626 13.0303 11.4697C12.7374 11.1768 12.2626 11.1768 11.9697 11.4697L13.0303 12.5303ZM11.9697 11.4697C11.6768 11.7626 11.6768 12.2374 11.9697 12.5303C12.2626 12.8232 12.7374 12.8232 13.0303 12.5303L11.9697 11.4697ZM18.0303 7.53033C18.3232 7.23744 18.3232 6.76256 18.0303 6.46967C17.7374 6.17678 17.2626 6.17678 16.9697 6.46967L18.0303 7.53033ZM13.0303 11.4697C12.7374 11.1768 12.2626 11.1768 11.9697 11.4697C11.6768 11.7626 11.6768 12.2374 11.9697 12.5303L13.0303 11.4697ZM16.9697 17.5303C17.2626 17.8232 17.7374 17.8232 18.0303 17.5303C18.3232 17.2374 18.3232 16.7626 18.0303 16.4697L16.9697 17.5303ZM11.9697 12.5303C12.2626 12.8232 12.7374 12.8232 13.0303 12.5303C13.3232 12.2374 13.3232 11.7626 13.0303 11.4697L11.9697 12.5303ZM8.03033 6.46967C7.73744 6.17678 7.26256 6.17678 6.96967 6.46967C6.67678 6.76256 6.67678 7.23744 6.96967 7.53033L8.03033 6.46967ZM8.03033 17.5303L13.0303 12.5303L11.9697 11.4697L6.96967 16.4697L8.03033 17.5303ZM13.0303 12.5303L18.0303 7.53033L16.9697 6.46967L11.9697 11.4697L13.0303 12.5303ZM11.9697 12.5303L16.9697 17.5303L18.0303 16.4697L13.0303 11.4697L11.9697 12.5303ZM13.0303 11.4697L8.03033 6.46967L6.96967 7.53033L11.9697 12.5303L13.0303 11.4697Z" fill="#000000"></path> </g></svg>
                </span>
              </button>

              <div className="search-bar relative w-full flex items-center">
                <div className="search-input w-full">
                  <input
                    type="text"
                    className="w-full border rounded-md border-gray-300 py-[0.5rem] placeholder:pb-2 text-[16px]"
                    placeholder="ابحث في بصمتي"
                    onChange={e => {
                      setSearch(e.target.value)
                    }}
                  />
                </div>
                <Button
                  type="submit"
                  bg="primary"
                  onClick={e => {
                    e.preventDefault()
                    SubmitSearch({ queryFromButton: search })
                  }}
                  classes={[
                    'left-0 text-white block absolute py-1 h-full px-3 rounded-l-md',
                  ]}>
                  <svg
                    width="20"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_919_8804)">
                      <path
                        d="M23.7078 22.7938L17.7388 16.8248C19.3654 14.8354 20.1651 12.2969 19.9726 9.73432C19.7801 7.17179 18.61 4.78129 16.7043 3.05728C14.7987 1.33327 12.3034 0.407651 9.7344 0.471883C7.16545 0.536114 4.71946 1.58528 2.90237 3.40237C1.08528 5.21946 0.0361144 7.66545 -0.0281174 10.2344C-0.0923492 12.8034 0.833269 15.2987 2.55728 17.2043C4.28129 19.11 6.67179 20.2801 9.23432 20.4726C11.7969 20.6651 14.3354 19.8654 16.3248 18.2388L22.2938 24.2078C22.4824 24.3899 22.735 24.4907 22.9972 24.4884C23.2594 24.4862 23.5102 24.381 23.6956 24.1956C23.881 24.0102 23.9862 23.7594 23.9884 23.4972C23.9907 23.235 23.8899 22.9824 23.7078 22.7938ZM10.0008 18.5008C8.41851 18.5008 6.87179 18.0316 5.5562 17.1525C4.2406 16.2735 3.21522 15.024 2.60972 13.5622C2.00422 12.1004 1.84579 10.4919 2.15448 8.94004C2.46316 7.38819 3.22508 5.96272 4.3439 4.8439C5.46272 3.72508 6.88819 2.96316 8.44004 2.65448C9.99189 2.34579 11.6004 2.50422 13.0622 3.10972C14.524 3.71522 15.7735 4.7406 16.6525 6.0562C17.5316 7.37179 18.0008 8.91851 18.0008 10.5008C17.9984 12.6218 17.1548 14.6552 15.655 16.155C14.1552 17.6548 12.1218 18.4984 10.0008 18.5008Z"
                        fill="#fff"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_919_8804">
                        <rect
                          width="24"
                          height="24"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </Button>
              </div>

              <div className='flex flex-col w-full'>
                <p className='mb-6 font-medium text-lg'>{'عمليات البحث المقترحة'}</p>
                <div className='flex flex-row gap-2 flex-wrap'>
                  {suggestedSearches?.map((item, index) => (
                    <button
                      key={index}
                      className='text-base text-success px-3 py-1 rounded-full border-2 border-success hover:text-success-600 hover:border-success-600 transition-all ease-in-out'
                      onClick={e => {
                        e.preventDefault()
                        SubmitSearch({ queryFromButton: item.text })
                      }}
                    >{item.text}</button>
                  ))}
                </div>
              </div>

              <div className='flex flex-col w-full'>
                <p className='mb-6 font-medium text-lg'>{'الأكثر مبيعًا'}</p>
                <div className='flex flex-col gap-2 flex-wrap'>
                  {bestSelling?.map((item, index) => (
                    <div
                      key={index}
                      className='text-base text-primary-500'
                      onClick={e => {
                        e.preventDefault()
                        SubmitSearch({ queryFromButton: item.text })
                      }}
                    >{item.text}</div>
                  ))}
                </div>
              </div>
          </motion.div>
        )}
        </AnimatePresence>

        <div className="icons flex items-center gap-2">
          <a
            onClick={toggleClick}
            className="cursor-pointer flex flex-col items-center justify-center p-2 gap-1">
              <span className='w-8 h-8'>
                <svg viewBox="0 0 32 32" id="Filled_Line" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier"></g><g id="SVGRepo_tracerCarrier"></g><g id="SVGRepo_iconCarrier"><line fill="none" id="XMLID_837_" stroke="#200F60" x1="7" x2="25" y1="16" y2="16"></line><line fill="none" id="XMLID_836_" stroke="#200F60" x1="7" x2="25" y1="25" y2="25"></line><line fill="none" id="XMLID_835_" stroke="#200F60" x1="7" x2="25" y1="7" y2="7"></line></g></svg>
              </span>
          </a>
          <button className="search-icon p-2 cursor-pointer" onClick={() => setIsSearchOpen(true)}>
            <svg
              width="20"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_919_8804)">
                <path
                  d="M23.7078 22.7938L17.7388 16.8248C19.3654 14.8354 20.1651 12.2969 19.9726 9.73432C19.7801 7.17179 18.61 4.78129 16.7043 3.05728C14.7987 1.33327 12.3034 0.407651 9.7344 0.471883C7.16545 0.536114 4.71946 1.58528 2.90237 3.40237C1.08528 5.21946 0.0361144 7.66545 -0.0281174 10.2344C-0.0923492 12.8034 0.833269 15.2987 2.55728 17.2043C4.28129 19.11 6.67179 20.2801 9.23432 20.4726C11.7969 20.6651 14.3354 19.8654 16.3248 18.2388L22.2938 24.2078C22.4824 24.3899 22.735 24.4907 22.9972 24.4884C23.2594 24.4862 23.5102 24.381 23.6956 24.1956C23.881 24.0102 23.9862 23.7594 23.9884 23.4972C23.9907 23.235 23.8899 22.9824 23.7078 22.7938ZM10.0008 18.5008C8.41851 18.5008 6.87179 18.0316 5.5562 17.1525C4.2406 16.2735 3.21522 15.024 2.60972 13.5622C2.00422 12.1004 1.84579 10.4919 2.15448 8.94004C2.46316 7.38819 3.22508 5.96272 4.3439 4.8439C5.46272 3.72508 6.88819 2.96316 8.44004 2.65448C9.99189 2.34579 11.6004 2.50422 13.0622 3.10972C14.524 3.71522 15.7735 4.7406 16.6525 6.0562C17.5316 7.37179 18.0008 8.91851 18.0008 10.5008C17.9984 12.6218 17.1548 14.6552 15.655 16.155C14.1552 17.6548 12.1218 18.4984 10.0008 18.5008Z"
                  fill="black"
                />
              </g>
              <defs>
                <clipPath id="clip0_919_8804">
                  <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(0 0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
          </button>
        </div>

        <div className="icons flex items-center">
          <div className="logo">
            <Link href="/">
              <Image src={LogoImage} alt="logo-img" className="w-[105px]" />
            </Link>
          </div>
        </div>

        <div className="icons flex items-center gap-2">
          <a
            href="#"
            className="ml-2 p-2"
            onClick={e => {
              e.preventDefault()
              if (user) {
                router.push('/account')
              } else {
                if (lastOpened == 'register') {
                  setLastOpened('register')
                  setIsRegisterOpen(true)
                } else {
                  setLastOpened('login')
                  setIsLoginOpen(true)
                }
              }
            }}>
            <svg
              width="20"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_742_10744)">
                <path
                  d="M12 12.4999C13.1867 12.4999 14.3467 12.148 15.3334 11.4887C16.3201 10.8294 17.0892 9.89234 17.5433 8.79598C17.9974 7.69963 18.1162 6.49323 17.8847 5.32934C17.6532 4.16545 17.0818 3.09635 16.2426 2.25724C15.4035 1.41812 14.3344 0.84668 13.1705 0.615169C12.0067 0.383658 10.8003 0.502478 9.7039 0.956603C8.60754 1.41073 7.67047 2.17976 7.01118 3.16646C6.35189 4.15315 6 5.31319 6 6.49988C6.00159 8.09069 6.63424 9.61589 7.75911 10.7408C8.88399 11.8656 10.4092 12.4983 12 12.4999ZM12 2.49988C12.7911 2.49988 13.5645 2.73448 14.2223 3.174C14.8801 3.61353 15.3928 4.23824 15.6955 4.96915C15.9983 5.70005 16.0775 6.50432 15.9231 7.28024C15.7688 8.05617 15.3878 8.7689 14.8284 9.32831C14.269 9.88772 13.5563 10.2687 12.7804 10.423C12.0044 10.5774 11.2002 10.4981 10.4693 10.1954C9.73836 9.89265 9.11365 9.37996 8.67412 8.72216C8.2346 8.06436 8 7.29101 8 6.49988C8 5.43901 8.42143 4.4216 9.17157 3.67145C9.92172 2.92131 10.9391 2.49988 12 2.49988Z"
                  fill="#00214D"
                />
                <path
                  d="M12 14.5C9.61386 14.5026 7.32622 15.4517 5.63896 17.139C3.95171 18.8262 3.00265 21.1139 3 23.5C3 23.7652 3.10536 24.0196 3.29289 24.2071C3.48043 24.3946 3.73478 24.5 4 24.5C4.26522 24.5 4.51957 24.3946 4.70711 24.2071C4.89464 24.0196 5 23.7652 5 23.5C5 21.6435 5.7375 19.863 7.05025 18.5503C8.36301 17.2375 10.1435 16.5 12 16.5C13.8565 16.5 15.637 17.2375 16.9497 18.5503C18.2625 19.863 19 21.6435 19 23.5C19 23.7652 19.1054 24.0196 19.2929 24.2071C19.4804 24.3946 19.7348 24.5 20 24.5C20.2652 24.5 20.5196 24.3946 20.7071 24.2071C20.8946 24.0196 21 23.7652 21 23.5C20.9974 21.1139 20.0483 18.8262 18.361 17.139C16.6738 15.4517 14.3861 14.5026 12 14.5Z"
                  fill="#00214D"
                />
              </g>
              <defs>
                <clipPath id="clip0_742_10744">
                  <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(0 0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
          </a>

          <Link
            href="/cart"
            className="cart-icon bg-success p-1 rounded-full relative py-[.4rem] px-[.55rem]">
            <p className="bg-primary text-white w-[13px] h-[13px] flex items-center justify-center text-[.5rem] text-center rounded-full absolute cart-mob-counter">
              <span>{cart.items.length}</span>
            </p>
            <div className='h-full'>
              <CartIcon />
            </div>
          </Link>
        </div>
      </div>
      {/*
       * Mobile Overlay Menu Starts
       */}
      <AnimatePresence>
        {isNavOpen && (
          <motion.div
            initial={{opacity: 0.6, translateY: '-100%'}}
            transition={{ease: 'easeOut', duration: 0.3}}
            animate={{opacity: 1, translateY: '0'}}
            exit={{opacity: 0.6, translateY: '-100%'}}
            className={'showMenuNav lg:hidden'}>
            <div className="icons flex itemdss-center">
              <a
                onClick={toggleClick}
                className="menu-icon flex items-center justify-center">
                <svg
                  width="28"
                  height="27"
                  viewBox="0 0 28 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2 1.5L14.0208 13.5M14.0208 13.5L26 25.4584M14.0208 13.5L2 25.5M14.0208 13.5L26 1.54156"
                    stroke="white"
                    strokeWidth="3"
                    strokeLinecap="round"
                  />
                </svg>
              </a>
              <div className="logo mr-6">
                <Image src={LogoImage} alt="logo-img" className="w-[105px]" />
              </div>
            </div>
            <div
              id="mobileMenu"
              className="bg-white w-[100%] flex flex-col justify-evenly align-middle items-center mt-2 lg:hidden">
              <Link
                href="/"
                onClick={() => {
                  toggleClick()
                }}
                className="bg-success mt-8 w-[100%] flex flex-row justify-between align-middle items-center p-4 rounded-lg">
                <div className="flex flex-row align-middle items-center">
                  <div>
                    <svg
                      width="18"
                      height="19"
                      viewBox="0 0 18 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M6.33333 17.5H11.6667M6.33333 17.5H4.55556C3.61256 17.5 2.70819 17.1107 2.0414 16.4178C1.3746 15.725 1 14.7852 1 13.8053V7.99352C0.999987 7.35823 1.15761 6.73367 1.45766 6.18015C1.75771 5.62664 2.19003 5.16286 2.71289 4.83363L7.15733 2.03489C7.71299 1.68499 8.35028 1.5 9 1.5C9.64972 1.5 10.287 1.68499 10.8427 2.03489L15.2871 4.83363C15.8098 5.16278 16.2421 5.62641 16.5421 6.17975C16.8422 6.73309 16.9999 7.35747 17 7.9926V13.8053C17 14.7852 16.6254 15.725 15.9586 16.4178C15.2918 17.1107 14.3874 17.5 13.4444 17.5H11.6667H6.33333ZM6.33333 17.5V13.8053C6.33333 13.0704 6.61428 12.3656 7.11438 11.8459C7.61448 11.3262 8.29276 11.0343 9 11.0343V11.0343C9.70724 11.0343 10.3855 11.3262 10.8856 11.8459C11.3857 12.3656 11.6667 13.0704 11.6667 13.8053V17.5H6.33333Z"
                        stroke="#00214D"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <h1 className="mr-4 text-lg font-semibold text-center">
                    الرئيسية
                  </h1>
                </div>
                <div>
                  <svg
                    width="10"
                    height="15"
                    viewBox="0 0 10 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8 1.5L2 7.5L8 13.5"
                      stroke="#00214D"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </Link>
              {headerCategories?.map((category: any, index: number) => {
                return (
                  <Link
                    key={category.id}
                    onClick={() => {
                      toggleClick()
                    }}
                    className="w-full block"
                    href={`/products?categories=${category.slug}`}>
                    <MobileMenuItem key={category.id} title={category.name} />
                  </Link>
                )
              })}
              <LoggedInUserMobile
                setIsLoginOpen={setIsLoginOpen}
                setIsRegisterOpen={setIsRegisterOpen}
                setLastOpened={setLastOpened}
                lastOpened={lastOpened}
                toggleClick={toggleClick}
              />
              <MobileContactHeader />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}
